import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { mailingAPI } from "../api/api";
import { MailingActionTypes } from "../actions/actionTypes";
import _ from "lodash";

function* getMailingListTypes(action) {
    try {
        const listsTypes = yield call(() => mailingAPI.getMailingListTypes());

        yield put({
            type: MailingActionTypes.GET_MAILING_LISTS_TYPES_SUCCESS,
            payload: listsTypes.data
        });
    } catch (e) {
        API.handleError(e.response, "Error getting Mailing Lists Types.");

        yield put({
            type: MailingActionTypes.GET_MAILING_LISTS_TYPES_FAIL,
            message: e.message
        });
    }
}

export function* getMailingListTypestWatcher() {
    yield takeLatest(
        MailingActionTypes.GET_MAILING_LISTS_TYPES,
        getMailingListTypes
    );
}
